function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h64v64h-64z",
  fill: "#f7df1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.991746 50.000254c1.2891429 2.1048889 2.9663492 3.6520635 5.9326984 3.6520635 2.4919366 0 4.0838096-1.2454604 4.0838096-2.9663492 0-2.0622223-1.6355556-2.792635-4.3784127-3.992381l-1.5034921-.6450794c-4.3398095-1.8488889-7.2228571-4.1650793-7.2228571-9.0615873 0-4.5104762 3.4366984-7.9441269 8.807619-7.9441269 3.823746 0 6.5726984 1.3307936 8.5536508 4.815238l-4.6831746 3.0069842c-1.0311111-1.8488889-2.1434921-2.5772699-3.8704762-2.5772699-1.7615238 0-2.8779682 1.1174603-2.8779682 2.5772699 0 1.8041904 1.1174603 2.5346031 3.6977777 3.6520635l1.5034921.6440635c5.1098413 2.1912381 7.9949206 4.4251428 7.9949206 9.447619 0 5.4146032-4.2534603 8.3809524-9.9657143 8.3809524-5.5852698 0-9.1936507-2.6615873-10.959238-6.1500953zm-21.2449523.5211428c.9447619 1.6761905 1.8041904 3.0933334 3.8704761 3.0933334 1.9758731 0 3.2223492-.7730794 3.2223492-3.7790477v-20.4495238h6.0139683v20.5307937c0 6.2273016-3.6510476 9.0615873-8.9803175 9.0615873-4.8152381 0-7.6038095-2.4919365-9.0219682-5.4933334z",
  fill: "#000"
}));

function SvgIconJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJs);
export default __webpack_public_path__ + "static/media/icon-js.0005fec7.svg";
export { ForwardRef as ReactComponent };